import React from 'react'
import PropTypes from 'prop-types'
import { Box } from 'theme-ui'
import RichTextRenderer from '~/components/Content/RichText'

const ContentCallToAction = ({ content, type = 'primary' }) => {
  const richTextOptionsets = {
    primary: 'ctaPrimary',
    text: 'ctaText',
    textBody3: 'ctaTextBody3',
  }

  return (
    <Box sx={{ p: { m: 0 } }}>
      <RichTextRenderer
        richText={content}
        optionSet={richTextOptionsets[type]}
      />
    </Box>
  )
}

ContentCallToAction.propTypes = {
  content: PropTypes.shape({}),
}

export default ContentCallToAction
